"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Breakpoint = exports.Breakpoint = undefined;
(function (Breakpoint) {
    Breakpoint[Breakpoint["WEB"] = 0] = "WEB";
    Breakpoint["MOBILE"] = "320px";
})(Breakpoint || (exports.Breakpoint = Breakpoint = {}));
//# sourceMappingURL=breakpoint.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/design-system/config/enums/breakpoint.js
// module id = 959
// module chunks = 0